import React from "react";
import "../styles/Clients.css";

// Importa tus logos reales (SVG/PNG con fondo transparente)
import logo1 from "../assets/logos/Incauca.png";
import logo2 from "../assets/logos/Lucerna.png";
import logo3 from "../assets/logos/Mayaguez.png";
import logo4 from "../assets/logos/SanCarlos.png";
import logo5 from "../assets/logos/CafedelCampo.png";
import logo6 from "../assets/logos/Inmaculadacofffe.webp";
import logo7 from "../assets/logos/riopaila.png";

const logos = [
  { src: logo1, alt: "Incauca" },
  { src: logo2, alt: "Hacienda Lucerna" },
  { src: logo3, alt: "Ingenio Mayaguez" },
  { src: logo4, alt: "Ingenio San Carlos" },
  { src: logo5, alt: "Cafe del campo Organico" },
  { src: logo6, alt: "Inmaculada Coffe Farms" },
  { src: logo7, alt: "Rio Paila Castilla" },
];

export default function Clients() {
  // Duplicamos la lista para un loop suave e infinito
  const items = [...logos, ...logos];

  return (
    <section id="clientes" className="clients">
      <div className="clients-inner">
        <div className="clients-title">
          <span>Nuestros</span>
          <strong>Clientes</strong>
        </div>

        <div className="clients-rail" aria-label="Logos de clientes">
          <div className="clients-track">
            {items.map((l, i) => (
              <div className="client-logo" key={`${l.alt}-${i}`}>
                <img src={l.src} alt={l.alt} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
